import type { ModificationsList, Modifier } from '../../types';
import { createModifiersFactory } from './modifier';

// ─────────────────────────────────────────────────────────────────────────────

export function generateAdditions(params: Params): Modifier[] {
  const { initialModifications, activeModifications } = params;

  const generateModificationChanges = createModifiersFactory(initialModifications); // prettier-ignore
  const modificationChanges = activeModifications.flatMap(generateModificationChanges); // prettier-ignore

  return modificationChanges.filter(Boolean) as Modifier[];
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  initialModifications: ModificationsList;
  activeModifications: ModificationsList;
};
